import { getHttpClient } from "@/http-client";

const baseUrl = "api/boss/roles";
export function updateRole(id, role) {
  return getHttpClient().put(`${baseUrl}/${id}`, { role });
}
